import * as React from 'react';
import ContentBox from './ContentBox';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import ReleaseListSingle from './ReleaseListSingle';

export default function ReleaseList(props) {
  return (
    <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{width: '5%', paddingRight: 0}}></TableCell>
                    <TableCell sx={{width: '30%', paddingRight: 0}}><Typography variant="body1">Release</Typography></TableCell>
                    <TableCell sx={{width: '35%', paddingRight: 0}}><Typography variant="body1">Label</Typography></TableCell>
                    <TableCell sx={{width: '10%', paddingRight: 0}}><Typography variant="body1">Release Date</Typography></TableCell>
                    <TableCell align="center" sx={{width: '8%', paddingRight: 0}}><Typography variant="body1">Status</Typography></TableCell>
                    <TableCell sx={{width: '7%', paddingRight: 0}}></TableCell>
                </TableRow>
            </TableHead>
        </Table>
        <ContentBox sx={{p: 0}}>
            <Table>
                <TableBody>
                    { ( props.data.length > 0 ) ?
                        props.data.map((row) => (
                            <ReleaseListSingle key={row.getId()} data={row} />
                        ))
                    :
                    <TableRow>
                        <TableCell colSpan={5} sx={{width: '40%', paddingRight: 0, textAlign: 'center'}} component="th" scope="row">
                            <Typography variant="body1">No results to display</Typography>
                        </TableCell>
                    </TableRow>
                    }
                </TableBody>
            </Table>
        </ContentBox>
    </TableContainer>
  );
}